module.exports = __webpack_public_path__ + "img/file-earmark-break.63386c5a.svg";